module.exports = __webpack_public_path__ + "img/balkon_2.236ff695.jpg";